const createWidgetTemplateFactory = require('components-framework/widget/create_widget_template_factory');

module.exports = createWidgetTemplateFactory({
    viewClass: require('./view'),
    templates: {
        main: require('components/flights/stop_details_item/templates/mobile/main.html'),
    },
});
